export const CHECKOUT_URL = 'https://diagnostico-en.impultienda.ar/checkout/'
